export const getVarietyList = {
  url: '/admin/variety/pageVariety',
  method: 'get'
};

export const getVarietyDetail = {
  url: '/admin/variety/getVarietyInfo',
  method: 'get'
};

export const saveVariety = {
  url: '/admin/variety/saveOrUpdate',
  method: 'post'
};

export const varietyUpdateStatus = {
  url: '/admin/variety/updateStatus',
  method: 'post'
};

export const deleteVariety = {
  url: '/admin/variety/deleteByIds',
  method: 'post'
};

export const getVarietyGoodsList = {
  url: '/admin/variety/pageGoodsList',
  method: 'get'
};
